import { render, staticRenderFns } from "./DatatableFooter.vue?vue&type=template&id=145f2cc6&scoped=true&"
import script from "./DatatableFooter.vue?vue&type=script&lang=js&"
export * from "./DatatableFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f2cc6",
  null
  
)

export default component.exports